import { html } from 'lit';
import { TemplateResult } from 'lit/development';
import { EASMIconSet } from '../../types/iconSet';
import { FilterType } from '../genericTopData/types/types';

export const EMPTY_VALUE = '--';

export function createArtifactsInventoryColumns(
  columns: {
    firstLabel: string;
    firstValue: string;
    firstInventorySmartViewId: string;
    firstFilterType: FilterType;
    firstFilterDataArray: Array<any>;
    iconName: string;
  }[],
  navigateToInventory: (
    inventorySmartViewId: string,
    filterType: FilterType,
    filterData: string,
    filterDataArray: any[]
  ) => Promise<void>
) {
  return columns.map(column => {
    let firstTemplate: TemplateResult;
    const isClickable = column.firstValue !== EMPTY_VALUE;

    if (isClickable) {
      firstTemplate = html` <div class="value clickable">${column.firstValue}</div> `;
    } else {
      firstTemplate = html` <div class="value">${EMPTY_VALUE}</div> `;
    }

    return html`
      <div class="containers ${isClickable ? 'clickable' : ''}">
        <div
          class="first-item"
          @click="${async () =>
            await navigateToInventory(
              column.firstInventorySmartViewId,
              column.firstFilterType,
              '',
              column.firstFilterDataArray
            )}"
        >
          <gz-tooltip tooltipText="${column.firstLabel}"> ${EASMIconSet.createIconSet(column.iconName)} </gz-tooltip>
          <div class="icon-with-label">${EASMIconSet.createIconSet(column.iconName)}</div>
          <gz-title class="label" fontSize="12">${column.firstLabel}</gz-title>
          ${firstTemplate}
        </div>
      </div>
    `;
  });
}
